/**
 * Processes credit type and loan term changes for payment calculation
 * @param {string} key - The parameter key being updated
 * @param {*} value - The new value
 * @param selectedCreditTier
 * @param savedLoanTerm
 * @param selectedLoanTerm
 * @param obfuscatedCredit
 * @param nationalRates
 * @param ratesLabels
 * @param useCustomRate
 * @param customRate
 * @param isLoanTermCustom
 * @returns {Object} Processed credit and term data
 */
const getUpdatedCreditAndTermChanges = (key, value, savedLoanTerm, nationalRates, ratesLabels, isLoanTermCustom, udsLocalStateValues) => {
  const {
    selectedCreditTier,
    selectedLoanTerm,
    obfuscatedCredit,
    useCustomRate,
    customRate
  } = udsLocalStateValues;
  const isCreditType = key === 'creditType';
  const isLoanTerm = key === 'loanTerm';
  const creditTierRates = isCreditType ? value : selectedCreditTier;
  const derivedCreditTierRates = nationalRates[ratesLabels[creditTierRates]?.decodedValue];
  const termRates = isLoanTerm ? value : selectedLoanTerm;
  const derivedTermRates = derivedCreditTierRates.rates[termRates];
  const derivedCreditType = isCreditType ? value : obfuscatedCredit;
  const updatesCreditOrTerm = isCreditType || isLoanTerm;
  const rateObject = useCustomRate ? {
    custom: customRate,
    ...derivedTermRates
  } : {
    ...derivedTermRates
  };
  const updatedCreditType = isCreditType ? ratesLabels[value]?.decodedValue : selectedCreditTier;
  const updatedLoanTerm = isLoanTerm ? value : selectedLoanTerm;

  // check to ensure previousSelectedLoanTerm is not a custom value
  const previousSelectedLoanTerm = isLoanTermCustom(savedLoanTerm, updatedCreditType) ? 72 : savedLoanTerm;
  const fallBackLoanTerm = isLoanTermCustom(updatedLoanTerm, updatedCreditType) ? previousSelectedLoanTerm : null;
  return {
    isCreditType,
    isLoanTerm,
    derivedCreditType,
    updatesCreditOrTerm,
    rateObject,
    fallBackLoanTerm
  };
};
export { getUpdatedCreditAndTermChanges as default };
